import type { UniqueIdentifier } from '@dnd-kit/core';

/** Namespace prefix for a column's sortable-header dnd-kit id. */
export const COLUMN_SORTABLE_PREFIX = 'column:';

/** Builds the namespaced sortable id for a column's draggable header. */
export function columnSortableId(columnId: string): string {
    return `${COLUMN_SORTABLE_PREFIX}${columnId}`;
}

/**
 * Recovers the bare column id from a dnd-kit droppable/draggable id.
 *
 * dnd-kit's `useSortable({ disabled: boolean })` always keeps the underlying
 * droppable live (only pointer/keyboard sensors are disabled), so a column's
 * `column:<id>` sortable id can show up as `over.id` even during a plain card
 * drag (e.g. releasing over the header or footer area, which the column-root
 * droppable fully contains). Stripping the prefix here — rather than
 * disabling the droppable — lets a card dropped there resolve to the real
 * column id instead of the raw `column:<id>` string.
 */
export function columnIdFromDroppable(id: UniqueIdentifier): string {
    const value = String(id);
    return value.startsWith(COLUMN_SORTABLE_PREFIX)
        ? value.slice(COLUMN_SORTABLE_PREFIX.length)
        : value;
}
